import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-authoritiesdefinitions',
  imports: [],
  templateUrl: './authoritiesdefinitions.component.html',
  styleUrl: './authoritiesdefinitions.component.css'
})
export class AuthoritiesdefinitionsComponent {
  constructor(private router: Router) {
    this.downloadNotes();
  }

  downloadNotes() {
    const link = document.createElement('a');
    link.href = 'assets/Definitions_of_the_Authorities.doc';
    link.download = 'Definitions_of_the_Authorities.doc';
    link.click();
    this.router.navigate(['/DOA']);
}
}
